import { dateFromString, getDatesFromEntry, dateFromYearMonth } from "./date";

// textInput will be searched inside "headline", "text" and "location" property
export const filter = (
	textInput = "",
	topic = "",
	timespan = "",
	year = "",
	month = "",
	inputData = []) => {
	let filteredInput = inputData.slice();
	const today = new Date().getTime();
	const date = dateFromYearMonth(year, month, false);
	const topics = getTopicsFromInputData(inputData).sort();
	const topicsLowerCase = topics.map(t => t.toLocaleLowerCase());
	
	if (textInput) {
		const textInputLowerCase = textInput.toLocaleLowerCase();

		// Prüft, ob der User als Freitext ein Thema eingegeben hat. Falls ja wird nach dem Thema gefiltert,
		// anstatt die Eingabe als String in Headline und Teasertext zu suchen. So findet der User z. B. für
		// die Eingabe "EIT" passende Meldungen zu diesem Thema und nicht einfach nur Meldungen mit Begriffen
		// wie lEITung oder gesundhEITsforschung.
		const topicsIndex = topicsLowerCase.indexOf(textInputLowerCase);

		if (-1 === topicsIndex) {
			filteredInput = filteredInput.filter(entry =>
				entry.headline.toLocaleLowerCase().includes(textInputLowerCase) ||
				entry.text.toLocaleLowerCase().includes(textInputLowerCase)
			);
		} else {
			filteredInput = filteredInput.filter(entry => {
				return entry.keywords.indexOf(topics[ topicsIndex ]) !== -1;
			});
		}
	}

	// search entries for last x days
	if (timespan) {
		filteredInput = filteredInput.filter(entry => {
			const [ entryDateFrom ] = getDatesFromEntry(entry);
			if (entryDateFrom) {
				switch (timespan) {
					// all time
					case "0":
						return entry;
					// 2 weeks
					case "1":
						return entryDateFrom.getTime() > (today - 1209600000);
					// 1 month
					case "2":
						return entryDateFrom.getTime() > (today - 2629800000);
					// 3 months
					case "3":
						return entryDateFrom.getTime() > (today - 7889400000);
					// 1 year
					case "4":
						return entryDateFrom.getTime() > (today - 31557600000);
				}
			} else {
				return entry;
			}
		});
	}

	if (topic) {
		filteredInput = filteredInput.filter(entry => {
			return entry.keywords.indexOf(topics[ topic ]) !== -1;
		});
	}

	if (year) {
		filteredInput = filteredInput.filter(entry => {
			const [ entryDateFrom ] = getDatesFromEntry(entry);
			if (entryDateFrom) {
				if (month) {
					return entryDateFrom.getFullYear() === date.getFullYear() && entryDateFrom.getMonth() === date.getMonth();
				}
				return entryDateFrom.getFullYear() === date.getFullYear();
			}
			return entry;
		});
	}

	return filteredInput;
};

export const sortByFromDate = (inputData, asc = false) => {
	return inputData.sort((entryA, entryB) => {
		const [ entryAFrom ] = getDatesFromEntry(entryA);
		const [ entryBFrom ] = getDatesFromEntry(entryB);

		// sort entries without fromDate to the end of the list
		if (! entryAFrom && ! entryBFrom) {
			return 0;
		}
		if (! entryAFrom) {
			return 1;
		}
		if (! entryBFrom) {
			return -1;
		}
		if (asc) {
			return entryAFrom.getTime() - entryBFrom.getTime();
		}
		return entryBFrom.getTime() - entryAFrom.getTime();
	});
};

export const getTopicsFromInputData = (inputData) => {
	const topics = [];
	inputData.forEach((entry) => {
		entry.keywords.split(",").forEach((keyword) => {
			if (! topics.includes(keyword)) {
				topics.push(keyword);
			}
		});
	});
	return topics;
};

export const getFirstYearFromInputData = (inputData) => {
	let year = 9999;
	for (let i = 0; i < inputData.length; i++) {
		const date = dateFromString(inputData[ i ].dateFrom);
		if (date && date.getFullYear() < year) {
			year = date.getFullYear();
		}
	}
	return year;
};

export const getLastYearFromInputData = (inputData) => {
	let year = 0;
	for (let i = 0; i < inputData.length; i++) {
		const date = dateFromString(inputData[ i ].dateFrom);
		if (date && date.getFullYear() > year) {
			year = date.getFullYear();
		}
	}
	return year;
};

export const removePastItems = (items) => {
	const todayAtMidnight = new Date();
	todayAtMidnight.setHours(0, 0, 0, 0);

	items = items.filter(item => {
		const [ startDate ] = getDatesFromEntry(item);
		// always leave items without a parsable date in the list
		if (false === startDate) {
			return true;
		}
		return startDate.getTime() >= todayAtMidnight.getTime();
	});

	return items;
};
